import gql from 'graphql-tag';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  EmailAddress: { input: string; output: string; }
  Object: { input: any; output: any; }
  PhoneNumber: { input: string; output: string; }
  Timestamp: { input: number; output: number; }
  URL: { input: string; output: string; }
  UnsignedInt: { input: number; output: number; }
};

export type AggregatorCoupon = {
  __typename?: 'AggregatorCoupon';
  fixed: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  percentage: Scalars['Int']['output'];
  type: CouponType;
};

export type AggregatorCreateReservation = {
  __typename?: 'AggregatorCreateReservation';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  postReservationInstructions?: Maybe<Scalars['String']['output']>;
  status: AggregatorReservationStatus;
};

export type AggregatorCreateReservationInput = {
  availabilitySlotId: Scalars['String']['input'];
  couponInformations?: InputMaybe<CouponInput>;
  deviceOrigin?: InputMaybe<ReservationDeviceOrigin>;
  homeVisitInformations?: InputMaybe<HomeVisitInput>;
  includeIn730?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoConsultation: Scalars['Boolean']['input'];
  onBehalfOfInformations?: InputMaybe<OnBehalfOfInput>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentOnline: Scalars['Boolean']['input'];
  userBillingInformations?: InputMaybe<UserBillingInformations>;
  userEmail: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userNewsletterEnabled: Scalars['Boolean']['input'];
  userPhone: Scalars['String']['input'];
  userSurname: Scalars['String']['input'];
  userTaxCode: Scalars['String']['input'];
};

export type AggregatorDoctor = {
  __typename?: 'AggregatorDoctor';
  basePrice?: Maybe<Scalars['Int']['output']>;
  existsAvailabilities?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isNameVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nextAvailability?: Maybe<Scalars['Timestamp']['output']>;
  sex?: Maybe<Sex>;
  surname: Scalars['String']['output'];
  /** @deprecated unused, to be deleted */
  taxCode?: Maybe<Scalars['String']['output']>;
};

export type AggregatorPatient = {
  __typename?: 'AggregatorPatient';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
};

export enum AggregatorPaymentGateway {
  Davinci = 'DAVINCI',
  Stripe = 'STRIPE',
  Tantosvago = 'TANTOSVAGO',
  Welbee = 'WELBEE'
}

export enum AggregatorPaymentStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type AggregatorPaymentTransaction = {
  __typename?: 'AggregatorPaymentTransaction';
  amount?: Maybe<Scalars['Int']['output']>;
  amountToPay: Scalars['Int']['output'];
  origin: ReservationOrigin;
  paymentGateway?: Maybe<AggregatorPaymentGateway>;
  status: AggregatorPaymentStatus;
};

export type AggregatorReservation = {
  __typename?: 'AggregatorReservation';
  code: Scalars['String']['output'];
  doctorId: Scalars['String']['output'];
  homeVisit?: Maybe<HomeVisitInfo>;
  id: Scalars['String']['output'];
  onBehalfOf?: Maybe<OnBehalfOfUserInfo>;
  origin: AggregatorReservationOrigin;
  patient: AggregatorPatient;
  paymentTransaction: AggregatorPaymentTransaction;
  price?: Maybe<Scalars['UnsignedInt']['output']>;
  roomUrl?: Maybe<Scalars['String']['output']>;
  secret: Scalars['String']['output'];
  specialityId: Scalars['String']['output'];
  startTime: Scalars['Timestamp']['output'];
  status: AggregatorReservationStatus;
  workgroupId: Scalars['String']['output'];
};

export enum AggregatorReservationOrigin {
  Inclinic = 'INCLINIC',
  Welfare = 'WELFARE'
}

export enum AggregatorReservationStatus {
  Error = 'ERROR',
  Ongoing = 'ONGOING',
  Pending = 'PENDING'
}

export type AggregatorSlot = {
  __typename?: 'AggregatorSlot';
  doctorId: Scalars['String']['output'];
  end: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  specialityId: Scalars['String']['output'];
  start: Scalars['Timestamp']['output'];
  workgroupId: Scalars['String']['output'];
};

export type AggregatorSpeciality = {
  __typename?: 'AggregatorSpeciality';
  availablePayments?: Maybe<Array<PaymentType>>;
  branch?: Maybe<Scalars['String']['output']>;
  doctors?: Maybe<Array<Maybe<AggregatorDoctor>>>;
  eltyDescription?: Maybe<Scalars['String']['output']>;
  eltyName?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  hasDynamicPrice: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  macroSpeciality?: Maybe<MacroSpeciality>;
  medicalInstructions?: Maybe<Scalars['String']['output']>;
  nationalCode?: Maybe<Scalars['String']['output']>;
  nationalDescription?: Maybe<Scalars['String']['output']>;
  popularity?: Maybe<Scalars['Int']['output']>;
  /** @deprecated No longer supported */
  price?: Maybe<Scalars['Int']['output']>;
  specialityChannels?: Maybe<Array<SpecialityChannel>>;
};

export type AggregatorUpdateReservation = {
  __typename?: 'AggregatorUpdateReservation';
  isUpdated: Scalars['Boolean']['output'];
  postReservationInstructions?: Maybe<Scalars['String']['output']>;
  status: AggregatorReservationStatus;
};

export type AggregatorWorkgroup = {
  __typename?: 'AggregatorWorkgroup';
  address?: Maybe<StructuredAddress>;
  availablePayments?: Maybe<Array<PaymentType>>;
  clinic: Clinic;
  description?: Maybe<Scalars['String']['output']>;
  doctors: Array<AggregatorDoctor>;
  domiciliaryCare?: Maybe<Scalars['Boolean']['output']>;
  emails: Array<Scalars['EmailAddress']['output']>;
  id: Scalars['String']['output'];
  inclinicSlug?: Maybe<Scalars['String']['output']>;
  insurances?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use seo.logo instead */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  openingHours: Array<OpeningHours>;
  phones: Array<Scalars['PhoneNumber']['output']>;
  seo?: Maybe<AggregatorWorkgroupSeo>;
  showOnPrivate: Scalars['Boolean']['output'];
  specializations?: Maybe<Array<AggregatorSpeciality>>;
  /** @deprecated No longer supported */
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['URL']['output']>;
};

export type AggregatorWorkgroupFaq = {
  __typename?: 'AggregatorWorkgroupFAQ';
  answer: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isVisibleOnWelfare: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  workgroupId: Scalars['String']['output'];
};

export type AggregatorWorkgroupSeo = {
  __typename?: 'AggregatorWorkgroupSeo';
  images?: Maybe<Array<Maybe<Image>>>;
  logo?: Maybe<Image>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityGroup = {
  __typename?: 'AvailabilityGroup';
  availabilityCount: Scalars['Int']['output'];
  date: Scalars['Timestamp']['output'];
};

export enum AwinEventType {
  Abbonamento = 'ABBONAMENTO',
  Visita = 'VISITA'
}

export enum BillingOptions {
  NotRequired = 'NOT_REQUIRED',
  OnlineOnly = 'ONLINE_ONLY',
  Required = 'REQUIRED'
}

export type City = {
  __typename?: 'City';
  cfCode: Scalars['String']['output'];
  city: Scalars['String']['output'];
  cityCode: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
};

export type Clinic = {
  __typename?: 'Clinic';
  billingOptions: BillingOptions;
  id: Scalars['String']['output'];
  include730Required?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<License>;
  name: Scalars['String']['output'];
  /** @deprecated No longer supported */
  type?: Maybe<ClinicType>;
};

export enum ClinicType {
  Clinic = 'CLINIC',
  Specialist = 'SPECIALIST'
}

export type CouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
};

export enum CouponType {
  Acuore = 'ACUORE',
  Argento = 'ARGENTO',
  Cassalombarda = 'CASSALOMBARDA',
  Morato = 'MORATO',
  Refund = 'REFUND',
  RefundWelfare = 'REFUND_WELFARE',
  Sisalute = 'SISALUTE',
  Standard = 'STANDARD'
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DetailedSlot = {
  __typename?: 'DetailedSlot';
  basePrice?: Maybe<Scalars['Int']['output']>;
  doctor: SlotDoctor;
  end: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  slotPrice?: Maybe<Scalars['Int']['output']>;
  speciality: SlotSpeciality;
  start: Scalars['Timestamp']['output'];
  workgroup: SlotWorkgroup;
};

export type District = {
  __typename?: 'District';
  acronym: Scalars['String']['output'];
  district: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
  regionId: Scalars['Int']['output'];
};

export enum FlowType {
  Assurance = 'ASSURANCE',
  Private = 'PRIVATE',
  Welfare = 'WELFARE'
}

export type Geolocalization = {
  __typename?: 'Geolocalization';
  coordinates?: Maybe<Array<Scalars['Float']['output']>>;
  type: Scalars['String']['output'];
};

export type HomeVisitInfo = {
  __typename?: 'HomeVisitInfo';
  address: Scalars['String']['output'];
  cap: Scalars['String']['output'];
  city: Scalars['String']['output'];
  district: Scalars['String']['output'];
};

export type HomeVisitInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cap?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  isHomeVisit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum License {
  None = 'NONE',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type LicensedWorkgroupsPagedResult = {
  __typename?: 'LicensedWorkgroupsPagedResult';
  results: Array<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type LicensedWorkgroupsSlugsAndNamesPagedResult = {
  __typename?: 'LicensedWorkgroupsSlugsAndNamesPagedResult';
  results: Array<LicensedWorkgroupsSlugsAndNamesResult>;
  totalCount: Scalars['Int']['output'];
};

export type LicensedWorkgroupsSlugsAndNamesResult = {
  __typename?: 'LicensedWorkgroupsSlugsAndNamesResult';
  inclinicSlug: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum MacroSpeciality {
  Acupuncture = 'ACUPUNCTURE',
  AestheticMedicine = 'AESTHETIC_MEDICINE',
  Allergology = 'ALLERGOLOGY',
  Andrology = 'ANDROLOGY',
  Anesthesia = 'ANESTHESIA',
  Angiology = 'ANGIOLOGY',
  CardiacSurgery = 'CARDIAC_SURGERY',
  Cardiology = 'CARDIOLOGY',
  Chiropratic = 'CHIROPRATIC',
  ClinicalAnalysis = 'CLINICAL_ANALYSIS',
  Counselor = 'COUNSELOR',
  Default = 'DEFAULT',
  DefaultNurse = 'DEFAULT_NURSE',
  Dentistry = 'DENTISTRY',
  DermatologyAndVenereology = 'DERMATOLOGY_AND_VENEREOLOGY',
  Diagnostics = 'DIAGNOSTICS',
  Dietics = 'DIETICS',
  DiseasesOfTheCardiovascularSystem = 'DISEASES_OF_THE_CARDIOVASCULAR_SYSTEM',
  DiseasesOfTheDigestiveSystem = 'DISEASES_OF_THE_DIGESTIVE_SYSTEM',
  DiseasesOfTheRespiratorySystem = 'DISEASES_OF_THE_RESPIRATORY_SYSTEM',
  Ecography = 'ECOGRAPHY',
  EmergencyUrgencyMedicine = 'EMERGENCY_URGENCY_MEDICINE',
  EndocrinologyAndMetabolicDiseases = 'ENDOCRINOLOGY_AND_METABOLIC_DISEASES',
  ForensicMedicine = 'FORENSIC_MEDICINE',
  Gastroenterology = 'GASTROENTEROLOGY',
  GeneralMedicine = 'GENERAL_MEDICINE',
  GeneralSurgery = 'GENERAL_SURGERY',
  Genetics = 'GENETICS',
  Geriatrics = 'GERIATRICS',
  GynecologyAndObstetrics = 'GYNECOLOGY_AND_OBSTETRICS',
  Hematology = 'HEMATOLOGY',
  Homeopathy = 'HOMEOPATHY',
  HygieneAndPreventiveMedicine = 'HYGIENE_AND_PREVENTIVE_MEDICINE',
  Immunology = 'IMMUNOLOGY',
  InfectiousDiseaseAndTropicalDiseases = 'INFECTIOUS_DISEASE_AND_TROPICAL_DISEASES',
  InternalMedicine = 'INTERNAL_MEDICINE',
  Massotherapy = 'MASSOTHERAPY',
  MaxillofacialSurgery = 'MAXILLOFACIAL_SURGERY',
  Nephrology = 'NEPHROLOGY',
  NeurologicalRehabilitation = 'NEUROLOGICAL_REHABILITATION',
  Neurology = 'NEUROLOGY',
  Neuropsychiatry = 'NEUROPSYCHIATRY',
  NuclearMedicine = 'NUCLEAR_MEDICINE',
  Nursing = 'NURSING',
  Nutrition = 'NUTRITION',
  Obstetrics = 'OBSTETRICS',
  OccupationalMedicine = 'OCCUPATIONAL_MEDICINE',
  Oncology = 'ONCOLOGY',
  Ophthalmology = 'OPHTHALMOLOGY',
  OrthopedicsAndTraumatology = 'ORTHOPEDICS_AND_TRAUMATOLOGY',
  OrthopedicRehabilitation = 'ORTHOPEDIC_REHABILITATION',
  Orthoptistic = 'ORTHOPTISTIC',
  Osteopathy = 'OSTEOPATHY',
  Otolaryngology = 'OTOLARYNGOLOGY',
  PainTherapy = 'PAIN_THERAPY',
  Pediatrics = 'PEDIATRICS',
  PediatricOrthopedics = 'PEDIATRIC_ORTHOPEDICS',
  PediatricSurgery = 'PEDIATRIC_SURGERY',
  PharmaceuticalSciences = 'PHARMACEUTICAL_SCIENCES',
  Physiatry = 'PHYSIATRY',
  Physiotherapy = 'PHYSIOTHERAPY',
  PlasticSurgery = 'PLASTIC_SURGERY',
  Pmg = 'PMG',
  Pneumology = 'PNEUMOLOGY',
  Podiatry = 'PODIATRY',
  Prevention = 'PREVENTION',
  Proctology = 'PROCTOLOGY',
  Psychiatry = 'PSYCHIATRY',
  Psychology = 'PSYCHOLOGY',
  Radiology = 'RADIOLOGY',
  Rheumatology = 'RHEUMATOLOGY',
  Senology = 'SENOLOGY',
  Sexology = 'SEXOLOGY',
  SpeechTherapy = 'SPEECH_THERAPY',
  SportsMedicine = 'SPORTS_MEDICINE',
  SportPerformanceRehabilitation = 'SPORT_PERFORMANCE_REHABILITATION',
  ThermalMedicine = 'THERMAL_MEDICINE',
  ThoracicSurgery = 'THORACIC_SURGERY',
  TumorsOfTheHeadAndNeck = 'TUMORS_OF_THE_HEAD_AND_NECK',
  Urology = 'UROLOGY'
}

export type Mutation = {
  __typename?: 'Mutation';
  createReservation: AggregatorCreateReservation;
  createTantoSvagoReservationV2: AggregatorCreateReservation;
  deleteReservationByUser: Scalars['Boolean']['output'];
  updateReservationByUser: Scalars['Boolean']['output'];
  updateReservationByUserV2: AggregatorUpdateReservation;
};


export type MutationCreateReservationArgs = {
  input: AggregatorCreateReservationInput;
};


export type MutationCreateTantoSvagoReservationV2Args = {
  input: TantoSvagoReservationRequest;
};


export type MutationDeleteReservationByUserArgs = {
  motivation?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
};


export type MutationUpdateReservationByUserArgs = {
  secret: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
};


export type MutationUpdateReservationByUserV2Args = {
  secret: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
};

export type OnBehalfOfInput = {
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userSurname?: InputMaybe<Scalars['String']['input']>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
};

export type OnBehalfOfUserInfo = {
  __typename?: 'OnBehalfOfUserInfo';
  name: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
};

export type OpenFromTo = {
  __typename?: 'OpenFromTo';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  day: DayOfWeek;
  openHours: Array<OpenFromTo>;
};

export type PaymentIntentStatus = {
  __typename?: 'PaymentIntentStatus';
  status?: Maybe<Scalars['String']['output']>;
};

export enum PaymentType {
  Deferred = 'DEFERRED',
  Online = 'ONLINE',
  Onlywithcoupon = 'ONLYWITHCOUPON',
  Onsite = 'ONSITE'
}

export type PurchaseEventPayload = {
  index?: InputMaybe<Scalars['String']['input']>;
  item_brand?: InputMaybe<Scalars['String']['input']>;
  item_category?: InputMaybe<Scalars['String']['input']>;
  item_category5?: InputMaybe<Scalars['String']['input']>;
  item_id?: InputMaybe<Scalars['String']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_variant?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  availabilityDetailedSlotById: DetailedSlot;
  availabilityGroupByDate: Array<AvailabilityGroup>;
  /** @deprecated use availabilityDetailedSlotById instead */
  availabilitySlotById: AggregatorSlot;
  availabilitySlots: Array<AggregatorSlot>;
  /** @deprecated No longer supported */
  availabilitySlotsForSpecialityNoAuth: Array<AggregatorSlot>;
  checkCouponValidity: AggregatorCoupon;
  createPaymentIntent: StripeIntentResponse;
  decryptTantoSvagoSSO: TantoSvagoFields;
  faqsByWorkgroupId: Array<Maybe<AggregatorWorkgroupFaq>>;
  getCities: Array<City>;
  getDistricts: Array<District>;
  /** @deprecated No longer supported */
  licensedWorkgroupOnlyPrivateSlugs: LicensedWorkgroupsPagedResult;
  licensedWorkgroupOnlyPrivateSlugsAndNames: LicensedWorkgroupsSlugsAndNamesPagedResult;
  /** @deprecated No longer supported */
  licensedWorkgroupSlugs: LicensedWorkgroupsPagedResult;
  /** @deprecated No longer supported */
  licensedWorkgroupsIds: LicensedWorkgroupsPagedResult;
  reservationBySecretV2: AggregatorReservation;
  sendAwinEvent: Scalars['Boolean']['output'];
  sendPurchaseEvent: Scalars['Boolean']['output'];
  specialitiesByWorkgroupId: Array<AggregatorSpeciality>;
  specialityById: AggregatorSpeciality;
  syncProviderByIdLight?: Maybe<Scalars['Boolean']['output']>;
  unlicensedWorkgroups?: Maybe<Array<AggregatorWorkgroup>>;
  validateEmail?: Maybe<Scalars['Boolean']['output']>;
  validateTaxCode?: Maybe<Scalars['Boolean']['output']>;
  validateTaxCodeV2: TaxCodeResult;
  verifyPaymentIntentStatus?: Maybe<PaymentIntentStatus>;
  workgroupById: AggregatorWorkgroup;
  workgroupBySlug: AggregatorWorkgroup;
};


export type QueryAvailabilityDetailedSlotByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAvailabilityGroupByDateArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  doctorId: Scalars['String']['input'];
  isWelfareRequest?: InputMaybe<Scalars['Boolean']['input']>;
  specialityId: Scalars['String']['input'];
  startDate: Scalars['Timestamp']['input'];
  workgroupId: Scalars['ID']['input'];
};


export type QueryAvailabilitySlotByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAvailabilitySlotsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  doctorId?: InputMaybe<Scalars['String']['input']>;
  isWelfareRequest?: InputMaybe<Scalars['Boolean']['input']>;
  specialityId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  workgroupId: Scalars['String']['input'];
};


export type QueryAvailabilitySlotsForSpecialityNoAuthArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  doctorId: Scalars['String']['input'];
  isWelfareRequest?: InputMaybe<Scalars['Boolean']['input']>;
  specialityId: Scalars['String']['input'];
  startDate: Scalars['Timestamp']['input'];
  workgroupId: Scalars['ID']['input'];
};


export type QueryCheckCouponValidityArgs = {
  code: Scalars['String']['input'];
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreatePaymentIntentArgs = {
  availabilitySlotId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDecryptTantoSvagoSsoArgs = {
  sso: Scalars['String']['input'];
};


export type QueryFaqsByWorkgroupIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCitiesArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDistrictsArgs = {
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLicensedWorkgroupOnlyPrivateSlugsArgs = {
  input: QueryPagination;
};


export type QueryLicensedWorkgroupOnlyPrivateSlugsAndNamesArgs = {
  input: QueryPagination;
};


export type QueryLicensedWorkgroupSlugsArgs = {
  input: QueryPagination;
};


export type QueryLicensedWorkgroupsIdsArgs = {
  input: QueryPagination;
};


export type QueryReservationBySecretV2Args = {
  secret: Scalars['String']['input'];
};


export type QuerySendAwinEventArgs = {
  awc: Scalars['String']['input'];
  awinEventType: AwinEventType;
  orderReference: Scalars['String']['input'];
};


export type QuerySendPurchaseEventArgs = {
  payload: PurchaseEventPayload;
};


export type QuerySpecialitiesByWorkgroupIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpecialityByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySyncProviderByIdLightArgs = {
  id: Scalars['ID']['input'];
};


export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateTaxCodeArgs = {
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type QueryValidateTaxCodeV2Args = {
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};


export type QueryVerifyPaymentIntentStatusArgs = {
  paymentIntent: Scalars['String']['input'];
  stripeConnectedId: Scalars['String']['input'];
};


export type QueryWorkgroupByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkgroupBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type QueryPagination = {
  limit: Scalars['UnsignedInt']['input'];
  offset: Scalars['UnsignedInt']['input'];
  sorting?: InputMaybe<QuerySorting>;
};

export type QuerySorting = {
  field: Scalars['String']['input'];
  value: SortingDirection;
};

export enum ReservationDeviceOrigin {
  App = 'APP',
  Web = 'WEB'
}

export enum ReservationOrigin {
  Acuore = 'ACUORE',
  Argento = 'ARGENTO',
  Cassalombarda = 'CASSALOMBARDA',
  Inclinic = 'INCLINIC',
  Morato = 'MORATO',
  Sisalute = 'SISALUTE',
  TantoSvago = 'TANTO_SVAGO'
}

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type SlotDoctor = {
  __typename?: 'SlotDoctor';
  id: Scalars['String']['output'];
  isNameVisible: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type SlotSpeciality = {
  __typename?: 'SlotSpeciality';
  /** @deprecated No longer supported */
  basePrice?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  macroSpeciality?: Maybe<MacroSpeciality>;
  medicalInstructions?: Maybe<Scalars['String']['output']>;
  specialityChannels?: Maybe<Array<Maybe<SpecialityChannel>>>;
};

export type SlotWorkgroup = {
  __typename?: 'SlotWorkgroup';
  address?: Maybe<StructuredAddress>;
  availablePayments?: Maybe<Array<PaymentType>>;
  billingOptions: BillingOptions;
  domiciliaryCare?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  include730Required?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated No longer supported */
  stripeConnectId?: Maybe<Scalars['String']['output']>;
};

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SpecialityChannel {
  Domiciliary = 'DOMICILIARY',
  Online = 'ONLINE',
  Onsite = 'ONSITE'
}

export type StripeIntentResponse = {
  __typename?: 'StripeIntentResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentIntent?: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Int']['output'];
};

export type StructuredAddress = {
  __typename?: 'StructuredAddress';
  cap?: Maybe<Scalars['String']['output']>;
  cityCode: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  districtCode: Scalars['String']['output'];
  districtName: Scalars['String']['output'];
  location?: Maybe<Geolocalization>;
  street: Scalars['String']['output'];
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type TantoSvagoFields = {
  __typename?: 'TantoSvagoFields';
  apiHeaders: Scalars['Object']['output'];
  callbackUrl?: Maybe<Scalars['String']['output']>;
  contactText?: Maybe<Scalars['String']['output']>;
  endpointAsyncConfirmOrderUrl: Scalars['String']['output'];
  endpointAsyncOrderUrl: Scalars['String']['output'];
  endpointAsyncOrderWithPaymentGatewayUrl: Scalars['String']['output'];
  endpointDiscountCodeValidationUrl: Scalars['String']['output'];
  endpointSyncOrderUrl: Scalars['String']['output'];
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  paymentTypes: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  projectCode?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  userInfo: UserInfo;
};

export type TantoSvagoReservationRequest = {
  itemDescription: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  paymentType: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  reservationInfo: AggregatorCreateReservationInput;
  sso: Scalars['String']['input'];
};

export type TaxCodeResult = {
  __typename?: 'TaxCodeResult';
  isValid: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type UnlicensedWorkgroupsPagedResult = {
  __typename?: 'UnlicensedWorkgroupsPagedResult';
  results: Array<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type UserBillingInformations = {
  cap: Scalars['String']['input'];
  city: Scalars['String']['input'];
  district: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
};

export enum UserInclinicPayment {
  Deferred = 'DEFERRED',
  Online = 'ONLINE',
  Onlywithcoupon = 'ONLYWITHCOUPON',
  Onsite = 'ONSITE'
}

export type UserInfo = {
  __typename?: 'UserInfo';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type AvailabilitySlotsForSpecialityNoAuthQueryVariables = Exact<{
  startDate: Scalars['Timestamp']['input'];
  workgroupId: Scalars['ID']['input'];
  doctorId: Scalars['String']['input'];
  specialityId: Scalars['String']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AvailabilitySlotsForSpecialityNoAuthQueryResult = { __typename?: 'Query', availabilitySlotsForSpecialityNoAuth: Array<{ __typename?: 'AggregatorSlot', id: string, start: number, price?: number | null }> };

export type AvailabilityDetailedSlotByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AvailabilityDetailedSlotByIdQueryResult = { __typename?: 'Query', availabilityDetailedSlotById: { __typename?: 'DetailedSlot', id: string, start: number, end: number, basePrice?: number | null, slotPrice?: number | null, workgroup: { __typename?: 'SlotWorkgroup', id: string, name: string, availablePayments?: Array<PaymentType> | null, domiciliaryCare?: boolean | null, billingOptions: BillingOptions, include730Required?: boolean | null, address?: { __typename?: 'StructuredAddress', cityCode: string, cityName: string, districtName: string, street: string, streetNumber?: string | null, cap?: string | null, location?: { __typename?: 'Geolocalization', type: string, coordinates?: Array<number> | null } | null } | null }, doctor: { __typename?: 'SlotDoctor', id: string, name?: string | null, surname?: string | null, isNameVisible: boolean }, speciality: { __typename?: 'SlotSpeciality', id: string, label?: string | null, medicalInstructions?: string | null, specialityChannels?: Array<SpecialityChannel | null> | null, macroSpeciality?: MacroSpeciality | null } } };

export type AvailabilityGroupByDateQueryVariables = Exact<{
  startDate: Scalars['Timestamp']['input'];
  workgroupId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  doctorId: Scalars['String']['input'];
  specialityId: Scalars['String']['input'];
}>;


export type AvailabilityGroupByDateQueryResult = { __typename?: 'Query', availabilityGroupByDate: Array<{ __typename?: 'AvailabilityGroup', date: number, availabilityCount: number }> };

export type AvailabilitySlotsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  workgroupId: Scalars['String']['input'];
  doctorId: Scalars['String']['input'];
  specialityId: Scalars['String']['input'];
}>;


export type AvailabilitySlotsQueryResult = { __typename?: 'Query', availabilitySlots: Array<{ __typename?: 'AggregatorSlot', id: string, start: number, price?: number | null }> };

export type SendAwinEventQueryVariables = Exact<{
  orderReference: Scalars['String']['input'];
  awinEventType: AwinEventType;
  awc: Scalars['String']['input'];
}>;


export type SendAwinEventQueryResult = { __typename?: 'Query', sendAwinEvent: boolean };

export type CheckCouponValidityQueryVariables = Exact<{
  code: Scalars['String']['input'];
  macroSpeciality?: InputMaybe<MacroSpeciality>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckCouponValidityQueryResult = { __typename?: 'Query', checkCouponValidity: { __typename?: 'AggregatorCoupon', id: string, fixed: number, percentage: number, type: CouponType } };

export type CreateReservationMutationVariables = Exact<{
  input: AggregatorCreateReservationInput;
}>;


export type CreateReservationMutationResult = { __typename?: 'Mutation', createReservation: { __typename?: 'AggregatorCreateReservation', code: string, message: string, status: AggregatorReservationStatus, postReservationInstructions?: string | null } };

export type DeleteReservationByUserMutationVariables = Exact<{
  secret: Scalars['String']['input'];
  motivation?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteReservationByUserMutationResult = { __typename?: 'Mutation', deleteReservationByUser: boolean };

export type FaqsByWorkgroupIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FaqsByWorkgroupIdQueryResult = { __typename?: 'Query', faqsByWorkgroupId: Array<{ __typename?: 'AggregatorWorkgroupFAQ', id: string, question: string, answer: string } | null> };

export type SendPurchaseEventQueryVariables = Exact<{
  payload: PurchaseEventPayload;
}>;


export type SendPurchaseEventQueryResult = { __typename?: 'Query', sendPurchaseEvent: boolean };

export type GetCitiesQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCitiesQueryResult = { __typename?: 'Query', getCities: Array<{ __typename?: 'City', city: string, cityCode: string, districtCode: string }> };

export type GetDistrictsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDistrictsQueryResult = { __typename?: 'Query', getDistricts: Array<{ __typename?: 'District', district: string, districtCode: string, acronym: string }> };

export type ReservationBySecretV2QueryVariables = Exact<{
  secret: Scalars['String']['input'];
}>;


export type ReservationBySecretV2QueryResult = { __typename?: 'Query', reservationBySecretV2: { __typename?: 'AggregatorReservation', id: string, price?: number | null, code: string, secret: string, origin: AggregatorReservationOrigin, startTime: number, status: AggregatorReservationStatus, workgroupId: string, specialityId: string, doctorId: string, roomUrl?: string | null, onBehalfOf?: { __typename?: 'OnBehalfOfUserInfo', name: string, surname: string, taxCode: string } | null, homeVisit?: { __typename?: 'HomeVisitInfo', district: string, city: string, address: string, cap: string } | null, paymentTransaction: { __typename?: 'AggregatorPaymentTransaction', paymentGateway?: AggregatorPaymentGateway | null, status: AggregatorPaymentStatus, amount?: number | null, amountToPay: number, origin: ReservationOrigin }, patient: { __typename?: 'AggregatorPatient', name: string, surname: string, taxCode: string, email?: string | null } } };

export type SpecialitiesByWorkgroupIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SpecialitiesByWorkgroupIdQueryResult = { __typename?: 'Query', specialitiesByWorkgroupId: Array<{ __typename?: 'AggregatorSpeciality', id?: string | null, label: string, specialityChannels?: Array<SpecialityChannel> | null, macroSpeciality?: MacroSpeciality | null, medicalInstructions?: string | null, favorite?: boolean | null, hasDynamicPrice: boolean, doctors?: Array<{ __typename?: 'AggregatorDoctor', id: string, name: string, surname: string, sex?: Sex | null, isNameVisible: boolean, nextAvailability?: number | null, basePrice?: number | null } | null> | null }> };

export type SpecialityByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SpecialityByIdQueryResult = { __typename?: 'Query', specialityById: { __typename?: 'AggregatorSpeciality', id?: string | null, label: string, eltyDescription?: string | null, specialityChannels?: Array<SpecialityChannel> | null, macroSpeciality?: MacroSpeciality | null, medicalInstructions?: string | null, favorite?: boolean | null, doctors?: Array<{ __typename?: 'AggregatorDoctor', id: string, name: string, surname: string, sex?: Sex | null, isNameVisible: boolean, basePrice?: number | null } | null> | null } };

export type AggregatorLicensedIdsQueryVariables = Exact<{
  limit: Scalars['UnsignedInt']['input'];
  offset: Scalars['UnsignedInt']['input'];
}>;


export type AggregatorLicensedIdsQueryResult = { __typename?: 'Query', licensedWorkgroupsIds: { __typename?: 'LicensedWorkgroupsPagedResult', totalCount: number, results: Array<string> } };

export type AggregatorLicensedSlugsQueryVariables = Exact<{
  limit: Scalars['UnsignedInt']['input'];
  offset: Scalars['UnsignedInt']['input'];
}>;


export type AggregatorLicensedSlugsQueryResult = { __typename?: 'Query', licensedWorkgroupSlugs: { __typename?: 'LicensedWorkgroupsPagedResult', totalCount: number, results: Array<string> } };

export type LicensedWorkgroupOnlyPrivateSlugsAndNamesQueryVariables = Exact<{
  limit: Scalars['UnsignedInt']['input'];
  offset: Scalars['UnsignedInt']['input'];
}>;


export type LicensedWorkgroupOnlyPrivateSlugsAndNamesQueryResult = { __typename?: 'Query', licensedWorkgroupOnlyPrivateSlugsAndNames: { __typename?: 'LicensedWorkgroupsSlugsAndNamesPagedResult', totalCount: number, results: Array<{ __typename?: 'LicensedWorkgroupsSlugsAndNamesResult', inclinicSlug: string, name: string }> } };

export type GetUnlicensedAggregatorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnlicensedAggregatorQueryResult = { __typename?: 'Query', unlicensedWorkgroups?: Array<{ __typename?: 'AggregatorWorkgroup', id: string, inclinicSlug?: string | null, name: string }> | null };

export type CreatePaymentIntentQueryQueryVariables = Exact<{
  availabilitySlotId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userTaxCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePaymentIntentQueryQueryResult = { __typename?: 'Query', createPaymentIntent: { __typename?: 'StripeIntentResponse', clientSecret?: string | null, paymentIntent?: string | null } };

export type VerifyPaymentIntentStatusQueryVariables = Exact<{
  paymentIntent: Scalars['String']['input'];
  stripeConnectedId: Scalars['String']['input'];
}>;


export type VerifyPaymentIntentStatusQueryResult = { __typename?: 'Query', verifyPaymentIntentStatus?: { __typename?: 'PaymentIntentStatus', status?: string | null } | null };

export type DecryptTantoSvagoSsoQueryVariables = Exact<{
  sso: Scalars['String']['input'];
}>;


export type DecryptTantoSvagoSsoQueryResult = { __typename?: 'Query', decryptTantoSvagoSSO: { __typename?: 'TantoSvagoFields', endpointSyncOrderUrl: string, endpointAsyncOrderUrl: string, endpointAsyncConfirmOrderUrl: string, endpointDiscountCodeValidationUrl: string, endpointAsyncOrderWithPaymentGatewayUrl: string, apiHeaders: any, logoImageUrl?: string | null, contactText?: string | null, primaryColor?: string | null, secondaryColor?: string | null, projectCode?: string | null, tag?: string | null, paymentTypes: string, callbackUrl?: string | null, userInfo: { __typename?: 'UserInfo', firstName?: string | null, lastName?: string | null, email?: string | null, userId: string, ssn?: string | null, phone?: string | null } } };

export type CreateTantoSvagoReservationV2MutationVariables = Exact<{
  input: TantoSvagoReservationRequest;
}>;


export type CreateTantoSvagoReservationV2MutationResult = { __typename?: 'Mutation', createTantoSvagoReservationV2: { __typename?: 'AggregatorCreateReservation', status: AggregatorReservationStatus, message: string } };

export type UpdateReservationByUserV2MutationVariables = Exact<{
  secret: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}>;


export type UpdateReservationByUserV2MutationResult = { __typename?: 'Mutation', updateReservationByUserV2: { __typename?: 'AggregatorUpdateReservation', isUpdated: boolean, status: AggregatorReservationStatus, postReservationInstructions?: string | null } };

export type ValidateEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ValidateEmailQueryResult = { __typename?: 'Query', validateEmail?: boolean | null };

export type ValidateTaxCodeV2QueryVariables = Exact<{
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
}>;


export type ValidateTaxCodeV2QueryResult = { __typename?: 'Query', validateTaxCodeV2: { __typename?: 'TaxCodeResult', isValid: boolean, message?: string | null, type?: number | null } };

export type WorkgroupByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkgroupByIdQueryResult = { __typename?: 'Query', workgroupById: { __typename?: 'AggregatorWorkgroup', availablePayments?: Array<PaymentType> | null, description?: string | null, domiciliaryCare?: boolean | null, emails: Array<string>, id: string, inclinicSlug?: string | null, logoUrl?: string | null, name: string, phones: Array<string>, website?: string | null, showOnPrivate: boolean, address?: { __typename?: 'StructuredAddress', cityCode: string, cityName: string, districtName: string, street: string, streetNumber?: string | null, cap?: string | null, location?: { __typename?: 'Geolocalization', type: string, coordinates?: Array<number> | null } | null } | null, clinic: { __typename?: 'Clinic', id: string, name: string, license?: License | null, type?: ClinicType | null, billingOptions: BillingOptions }, doctors: Array<{ __typename?: 'AggregatorDoctor', id: string, name: string, surname: string, sex?: Sex | null, isNameVisible: boolean, nextAvailability?: number | null }>, openingHours: Array<{ __typename?: 'OpeningHours', day: DayOfWeek, openHours: Array<{ __typename?: 'OpenFromTo', from: string, to: string }> }>, specializations?: Array<{ __typename?: 'AggregatorSpeciality', id?: string | null, label: string, specialityChannels?: Array<SpecialityChannel> | null, macroSpeciality?: MacroSpeciality | null, favorite?: boolean | null, hasDynamicPrice: boolean, doctors?: Array<{ __typename?: 'AggregatorDoctor', id: string, name: string, surname: string, isNameVisible: boolean, nextAvailability?: number | null, basePrice?: number | null } | null> | null }> | null } };

export type WorkgroupBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type WorkgroupBySlugQueryResult = { __typename?: 'Query', workgroupBySlug: { __typename?: 'AggregatorWorkgroup', availablePayments?: Array<PaymentType> | null, description?: string | null, domiciliaryCare?: boolean | null, emails: Array<string>, id: string, inclinicSlug?: string | null, logoUrl?: string | null, name: string, phones: Array<string>, website?: string | null, showOnPrivate: boolean, address?: { __typename?: 'StructuredAddress', cityName: string, districtName: string, street: string, streetNumber?: string | null, cap?: string | null, location?: { __typename?: 'Geolocalization', type: string, coordinates?: Array<number> | null } | null } | null, clinic: { __typename?: 'Clinic', id: string, name: string, license?: License | null, type?: ClinicType | null, billingOptions: BillingOptions }, openingHours: Array<{ __typename?: 'OpeningHours', day: DayOfWeek, openHours: Array<{ __typename?: 'OpenFromTo', from: string, to: string }> }>, seo?: { __typename?: 'AggregatorWorkgroupSeo', metaTitle?: string | null, metaDescription?: string | null, logo?: { __typename?: 'Image', url?: string | null, altText?: string | null } | null, images?: Array<{ __typename?: 'Image', url?: string | null, altText?: string | null } | null> | null } | null, specializations?: Array<{ __typename?: 'AggregatorSpeciality', id?: string | null, label: string, specialityChannels?: Array<SpecialityChannel> | null, macroSpeciality?: MacroSpeciality | null, favorite?: boolean | null, hasDynamicPrice: boolean, eltyDescription?: string | null, doctors?: Array<{ __typename?: 'AggregatorDoctor', id: string, name: string, surname: string, isNameVisible: boolean, nextAvailability?: number | null, basePrice?: number | null } | null> | null }> | null } };


export const AvailabilitySlotsForSpecialityNoAuth = gql`
    query AvailabilitySlotsForSpecialityNoAuth($startDate: Timestamp!, $workgroupId: ID!, $doctorId: String!, $specialityId: String!, $days: Int) {
  availabilitySlotsForSpecialityNoAuth(
    startDate: $startDate
    workgroupId: $workgroupId
    doctorId: $doctorId
    specialityId: $specialityId
    days: $days
  ) {
    id
    start
    price
  }
}
    `;
export const AvailabilityDetailedSlotById = gql`
    query AvailabilityDetailedSlotById($id: ID!) {
  availabilityDetailedSlotById(id: $id) {
    id
    start
    end
    workgroup {
      id
      name
      availablePayments
      domiciliaryCare
      billingOptions
      include730Required
      address {
        cityCode
        cityName
        districtName
        street
        streetNumber
        cap
        location {
          type
          coordinates
        }
      }
    }
    doctor {
      id
      name
      surname
      isNameVisible
    }
    speciality {
      id
      label
      medicalInstructions
      specialityChannels
      macroSpeciality
    }
    basePrice
    slotPrice
  }
}
    `;
export const AvailabilityGroupByDate = gql`
    query AvailabilityGroupByDate($startDate: Timestamp!, $workgroupId: ID!, $days: Int, $doctorId: String!, $specialityId: String!) {
  availabilityGroupByDate(
    startDate: $startDate
    workgroupId: $workgroupId
    doctorId: $doctorId
    specialityId: $specialityId
    days: $days
  ) {
    date
    availabilityCount
  }
}
    `;
export const AvailabilitySlots = gql`
    query AvailabilitySlots($startDate: Timestamp, $workgroupId: String!, $doctorId: String!, $specialityId: String!) {
  availabilitySlots(
    startDate: $startDate
    workgroupId: $workgroupId
    doctorId: $doctorId
    specialityId: $specialityId
  ) {
    id
    start
    price
  }
}
    `;
export const SendAwinEvent = gql`
    query SendAwinEvent($orderReference: String!, $awinEventType: AwinEventType!, $awc: String!) {
  sendAwinEvent(
    orderReference: $orderReference
    awinEventType: $awinEventType
    awc: $awc
  )
}
    `;
export const CheckCouponValidity = gql`
    query checkCouponValidity($code: String!, $macroSpeciality: MacroSpeciality, $userTaxCode: String) {
  checkCouponValidity(
    code: $code
    macroSpeciality: $macroSpeciality
    userTaxCode: $userTaxCode
  ) {
    id
    fixed
    percentage
    type
  }
}
    `;
export const CreateReservation = gql`
    mutation CreateReservation($input: AggregatorCreateReservationInput!) {
  createReservation(input: $input) {
    code
    message
    status
    postReservationInstructions
  }
}
    `;
export const DeleteReservationByUser = gql`
    mutation DeleteReservationByUser($secret: String!, $motivation: String) {
  deleteReservationByUser(secret: $secret, motivation: $motivation)
}
    `;
export const FaqsByWorkgroupId = gql`
    query faqsByWorkgroupId($id: ID!) {
  faqsByWorkgroupId(id: $id) {
    id
    question
    answer
  }
}
    `;
export const SendPurchaseEvent = gql`
    query sendPurchaseEvent($payload: PurchaseEventPayload!) {
  sendPurchaseEvent(payload: $payload)
}
    `;
export const GetCities = gql`
    query GetCities($term: String) {
  getCities(term: $term) {
    city
    cityCode
    districtCode
  }
}
    `;
export const GetDistricts = gql`
    query GetDistricts($term: String) {
  getDistricts(term: $term) {
    district
    districtCode
    acronym
  }
}
    `;
export const ReservationBySecretV2 = gql`
    query ReservationBySecretV2($secret: String!) {
  reservationBySecretV2(secret: $secret) {
    id
    price
    code
    secret
    origin
    startTime
    status
    onBehalfOf {
      name
      surname
      taxCode
    }
    homeVisit {
      district
      city
      address
      cap
    }
    paymentTransaction {
      paymentGateway
      status
      amount
      amountToPay
      origin
    }
    workgroupId
    specialityId
    patient {
      name
      surname
      taxCode
      email
    }
    doctorId
    roomUrl
  }
}
    `;
export const SpecialitiesByWorkgroupId = gql`
    query specialitiesByWorkgroupId($id: ID!) {
  specialitiesByWorkgroupId(id: $id) {
    id
    label
    specialityChannels
    macroSpeciality
    medicalInstructions
    favorite
    hasDynamicPrice
    doctors {
      id
      name
      surname
      sex
      isNameVisible
      nextAvailability
      basePrice
    }
  }
}
    `;
export const SpecialityById = gql`
    query SpecialityById($id: ID!) {
  specialityById(id: $id) {
    id
    label
    eltyDescription
    specialityChannels
    macroSpeciality
    medicalInstructions
    favorite
    doctors {
      id
      name
      surname
      sex
      isNameVisible
      basePrice
    }
  }
}
    `;
export const AggregatorLicensedIds = gql`
    query AggregatorLicensedIds($limit: UnsignedInt!, $offset: UnsignedInt!) {
  licensedWorkgroupsIds(
    input: {limit: $limit, offset: $offset, sorting: {field: "id", value: ASC}}
  ) {
    totalCount
    results
  }
}
    `;
export const AggregatorLicensedSlugs = gql`
    query AggregatorLicensedSlugs($limit: UnsignedInt!, $offset: UnsignedInt!) {
  licensedWorkgroupSlugs(
    input: {limit: $limit, offset: $offset, sorting: {field: "id", value: ASC}}
  ) {
    totalCount
    results
  }
}
    `;
export const LicensedWorkgroupOnlyPrivateSlugsAndNames = gql`
    query LicensedWorkgroupOnlyPrivateSlugsAndNames($limit: UnsignedInt!, $offset: UnsignedInt!) {
  licensedWorkgroupOnlyPrivateSlugsAndNames(
    input: {limit: $limit, offset: $offset, sorting: {field: "id", value: ASC}}
  ) {
    totalCount
    results {
      inclinicSlug
      name
    }
  }
}
    `;
export const GetUnlicensedAggregator = gql`
    query GetUnlicensedAggregator {
  unlicensedWorkgroups {
    id
    inclinicSlug
    name
  }
}
    `;
export const CreatePaymentIntentQuery = gql`
    query createPaymentIntentQuery($availabilitySlotId: String!, $couponCode: String, $userName: String, $userTaxCode: String) {
  createPaymentIntent(
    availabilitySlotId: $availabilitySlotId
    couponCode: $couponCode
    userName: $userName
    userTaxCode: $userTaxCode
  ) {
    clientSecret
    paymentIntent
  }
}
    `;
export const VerifyPaymentIntentStatus = gql`
    query verifyPaymentIntentStatus($paymentIntent: String!, $stripeConnectedId: String!) {
  verifyPaymentIntentStatus(
    paymentIntent: $paymentIntent
    stripeConnectedId: $stripeConnectedId
  ) {
    status
  }
}
    `;
export const DecryptTantoSvagoSso = gql`
    query decryptTantoSvagoSSO($sso: String!) {
  decryptTantoSvagoSSO(sso: $sso) {
    endpointSyncOrderUrl
    endpointAsyncOrderUrl
    endpointAsyncConfirmOrderUrl
    endpointDiscountCodeValidationUrl
    endpointAsyncOrderWithPaymentGatewayUrl
    apiHeaders
    logoImageUrl
    contactText
    primaryColor
    secondaryColor
    projectCode
    tag
    paymentTypes
    callbackUrl
    userInfo {
      firstName
      lastName
      email
      userId
      ssn
      phone
    }
  }
}
    `;
export const CreateTantoSvagoReservationV2 = gql`
    mutation CreateTantoSvagoReservationV2($input: TantoSvagoReservationRequest!) {
  createTantoSvagoReservationV2(input: $input) {
    status
    message
  }
}
    `;
export const UpdateReservationByUserV2 = gql`
    mutation UpdateReservationByUserV2($secret: String!, $slotId: String!) {
  updateReservationByUserV2(secret: $secret, slotId: $slotId) {
    isUpdated
    status
    postReservationInstructions
  }
}
    `;
export const ValidateEmail = gql`
    query validateEmail($email: String!) {
  validateEmail(email: $email)
}
    `;
export const ValidateTaxCodeV2 = gql`
    query validateTaxCodeV2($name: String!, $surname: String!, $taxCode: String!) {
  validateTaxCodeV2(name: $name, surname: $surname, taxCode: $taxCode) {
    isValid
    message
    type
  }
}
    `;
export const WorkgroupById = gql`
    query WorkgroupById($id: ID!) {
  workgroupById(id: $id) {
    address {
      cityCode
      cityName
      districtName
      street
      streetNumber
      cap
      location {
        type
        coordinates
      }
    }
    availablePayments
    clinic {
      id
      name
      license
      type
      billingOptions
    }
    description
    doctors {
      id
      name
      surname
      sex
      isNameVisible
      nextAvailability
    }
    domiciliaryCare
    emails
    id
    inclinicSlug
    logoUrl
    name
    openingHours {
      day
      openHours {
        from
        to
      }
    }
    phones
    specializations {
      id
      label
      specialityChannels
      macroSpeciality
      favorite
      hasDynamicPrice
      doctors {
        id
        name
        surname
        isNameVisible
        nextAvailability
        basePrice
      }
    }
    website
    showOnPrivate
  }
}
    `;
export const WorkgroupBySlug = gql`
    query WorkgroupBySlug($slug: String!) {
  workgroupBySlug(slug: $slug) {
    address {
      cityName
      districtName
      street
      streetNumber
      cap
      location {
        type
        coordinates
      }
    }
    availablePayments
    clinic {
      id
      name
      license
      type
      billingOptions
    }
    description
    domiciliaryCare
    emails
    id
    inclinicSlug
    logoUrl
    name
    openingHours {
      day
      openHours {
        from
        to
      }
    }
    seo {
      metaTitle
      metaDescription
      logo {
        url
        altText
      }
      images {
        url
        altText
      }
    }
    phones
    specializations {
      id
      label
      specialityChannels
      macroSpeciality
      favorite
      hasDynamicPrice
      eltyDescription
      doctors {
        id
        name
        surname
        isNameVisible
        nextAvailability
        basePrice
      }
    }
    website
    showOnPrivate
  }
}
    `;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    

export const AvailabilitySlotsForSpecialityNoAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailabilitySlotsForSpecialityNoAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availabilitySlotsForSpecialityNoAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"workgroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"specialityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<AvailabilitySlotsForSpecialityNoAuthQueryResult, AvailabilitySlotsForSpecialityNoAuthQueryVariables>;
export const AvailabilityDetailedSlotByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailabilityDetailedSlotById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availabilityDetailedSlotById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"workgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"availablePayments"}},{"kind":"Field","name":{"kind":"Name","value":"domiciliaryCare"}},{"kind":"Field","name":{"kind":"Name","value":"billingOptions"}},{"kind":"Field","name":{"kind":"Name","value":"include730Required"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"districtName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doctor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"isNameVisible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"speciality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"medicalInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"specialityChannels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"}},{"kind":"Field","name":{"kind":"Name","value":"slotPrice"}}]}}]}}]} as unknown as DocumentNode<AvailabilityDetailedSlotByIdQueryResult, AvailabilityDetailedSlotByIdQueryVariables>;
export const AvailabilityGroupByDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailabilityGroupByDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availabilityGroupByDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"workgroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"specialityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityCount"}}]}}]}}]} as unknown as DocumentNode<AvailabilityGroupByDateQueryResult, AvailabilityGroupByDateQueryVariables>;
export const AvailabilitySlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailabilitySlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availabilitySlots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"workgroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workgroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"doctorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doctorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"specialityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<AvailabilitySlotsQueryResult, AvailabilitySlotsQueryVariables>;
export const SendAwinEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SendAwinEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderReference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"awinEventType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AwinEventType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"awc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAwinEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderReference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderReference"}}},{"kind":"Argument","name":{"kind":"Name","value":"awinEventType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"awinEventType"}}},{"kind":"Argument","name":{"kind":"Name","value":"awc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"awc"}}}]}]}}]} as unknown as DocumentNode<SendAwinEventQueryResult, SendAwinEventQueryVariables>;
export const CheckCouponValidityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkCouponValidity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"macroSpeciality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MacroSpeciality"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userTaxCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkCouponValidity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"macroSpeciality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"macroSpeciality"}}},{"kind":"Argument","name":{"kind":"Name","value":"userTaxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userTaxCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixed"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<CheckCouponValidityQueryResult, CheckCouponValidityQueryVariables>;
export const CreateReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregatorCreateReservationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"postReservationInstructions"}}]}}]}}]} as unknown as DocumentNode<CreateReservationMutationResult, CreateReservationMutationVariables>;
export const DeleteReservationByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReservationByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secret"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"motivation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReservationByUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"secret"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secret"}}},{"kind":"Argument","name":{"kind":"Name","value":"motivation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"motivation"}}}]}]}}]} as unknown as DocumentNode<DeleteReservationByUserMutationResult, DeleteReservationByUserMutationVariables>;
export const FaqsByWorkgroupIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"faqsByWorkgroupId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faqsByWorkgroupId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]} as unknown as DocumentNode<FaqsByWorkgroupIdQueryResult, FaqsByWorkgroupIdQueryVariables>;
export const SendPurchaseEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sendPurchaseEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseEventPayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPurchaseEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}]}]}}]} as unknown as DocumentNode<SendPurchaseEventQueryResult, SendPurchaseEventQueryVariables>;
export const GetCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"term"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"term"},"value":{"kind":"Variable","name":{"kind":"Name","value":"term"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}}]}}]}}]} as unknown as DocumentNode<GetCitiesQueryResult, GetCitiesQueryVariables>;
export const GetDistrictsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDistricts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"term"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDistricts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"term"},"value":{"kind":"Variable","name":{"kind":"Name","value":"term"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"districtCode"}},{"kind":"Field","name":{"kind":"Name","value":"acronym"}}]}}]}}]} as unknown as DocumentNode<GetDistrictsQueryResult, GetDistrictsQueryVariables>;
export const ReservationBySecretV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReservationBySecretV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secret"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservationBySecretV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"secret"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secret"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGateway"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountToPay"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workgroupId"}},{"kind":"Field","name":{"kind":"Name","value":"specialityId"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doctorId"}},{"kind":"Field","name":{"kind":"Name","value":"roomUrl"}}]}}]}}]} as unknown as DocumentNode<ReservationBySecretV2QueryResult, ReservationBySecretV2QueryVariables>;
export const SpecialitiesByWorkgroupIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"specialitiesByWorkgroupId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialitiesByWorkgroupId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"specialityChannels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"medicalInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"hasDynamicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"doctors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isNameVisible"}},{"kind":"Field","name":{"kind":"Name","value":"nextAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialitiesByWorkgroupIdQueryResult, SpecialitiesByWorkgroupIdQueryVariables>;
export const SpecialityByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpecialityById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialityById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"eltyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"specialityChannels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"medicalInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"doctors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isNameVisible"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialityByIdQueryResult, SpecialityByIdQueryVariables>;
export const AggregatorLicensedIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregatorLicensedIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licensedWorkgroupsIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sorting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"id","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}}]}}]} as unknown as DocumentNode<AggregatorLicensedIdsQueryResult, AggregatorLicensedIdsQueryVariables>;
export const AggregatorLicensedSlugsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregatorLicensedSlugs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licensedWorkgroupSlugs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sorting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"id","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}}]}}]} as unknown as DocumentNode<AggregatorLicensedSlugsQueryResult, AggregatorLicensedSlugsQueryVariables>;
export const LicensedWorkgroupOnlyPrivateSlugsAndNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LicensedWorkgroupOnlyPrivateSlugsAndNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsignedInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licensedWorkgroupOnlyPrivateSlugsAndNames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sorting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"id","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inclinicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LicensedWorkgroupOnlyPrivateSlugsAndNamesQueryResult, LicensedWorkgroupOnlyPrivateSlugsAndNamesQueryVariables>;
export const GetUnlicensedAggregatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnlicensedAggregator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlicensedWorkgroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inclinicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUnlicensedAggregatorQueryResult, GetUnlicensedAggregatorQueryVariables>;
export const CreatePaymentIntentQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"createPaymentIntentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availabilitySlotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userTaxCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPaymentIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"availabilitySlotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availabilitySlotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"couponCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userTaxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userTaxCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntent"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentIntentQueryQueryResult, CreatePaymentIntentQueryQueryVariables>;
export const VerifyPaymentIntentStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"verifyPaymentIntentStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentIntent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeConnectedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyPaymentIntentStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentIntent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentIntent"}}},{"kind":"Argument","name":{"kind":"Name","value":"stripeConnectedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeConnectedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<VerifyPaymentIntentStatusQueryResult, VerifyPaymentIntentStatusQueryVariables>;
export const DecryptTantoSvagoSsoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"decryptTantoSvagoSSO"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decryptTantoSvagoSSO"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpointSyncOrderUrl"}},{"kind":"Field","name":{"kind":"Name","value":"endpointAsyncOrderUrl"}},{"kind":"Field","name":{"kind":"Name","value":"endpointAsyncConfirmOrderUrl"}},{"kind":"Field","name":{"kind":"Name","value":"endpointDiscountCodeValidationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"endpointAsyncOrderWithPaymentGatewayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiHeaders"}},{"kind":"Field","name":{"kind":"Name","value":"logoImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"contactText"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"projectCode"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"callbackUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"ssn"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<DecryptTantoSvagoSsoQueryResult, DecryptTantoSvagoSsoQueryVariables>;
export const CreateTantoSvagoReservationV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTantoSvagoReservationV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TantoSvagoReservationRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTantoSvagoReservationV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateTantoSvagoReservationV2MutationResult, CreateTantoSvagoReservationV2MutationVariables>;
export const UpdateReservationByUserV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReservationByUserV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secret"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReservationByUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"secret"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secret"}}},{"kind":"Argument","name":{"kind":"Name","value":"slotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"postReservationInstructions"}}]}}]}}]} as unknown as DocumentNode<UpdateReservationByUserV2MutationResult, UpdateReservationByUserV2MutationVariables>;
export const ValidateEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ValidateEmailQueryResult, ValidateEmailQueryVariables>;
export const ValidateTaxCodeV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateTaxCodeV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateTaxCodeV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"surname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"Argument","name":{"kind":"Name","value":"taxCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taxCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ValidateTaxCodeV2QueryResult, ValidateTaxCodeV2QueryVariables>;
export const WorkgroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkgroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workgroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityCode"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"districtName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePayments"}},{"kind":"Field","name":{"kind":"Name","value":"clinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"billingOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"doctors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"isNameVisible"}},{"kind":"Field","name":{"kind":"Name","value":"nextAvailability"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domiciliaryCare"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inclinicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"openHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"specializations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"specialityChannels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"hasDynamicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"doctors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"isNameVisible"}},{"kind":"Field","name":{"kind":"Name","value":"nextAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"showOnPrivate"}}]}}]}}]} as unknown as DocumentNode<WorkgroupByIdQueryResult, WorkgroupByIdQueryVariables>;
export const WorkgroupBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkgroupBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workgroupBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"districtName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePayments"}},{"kind":"Field","name":{"kind":"Name","value":"clinic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"billingOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"domiciliaryCare"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inclinicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"openHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"specializations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"specialityChannels"}},{"kind":"Field","name":{"kind":"Name","value":"macroSpeciality"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"hasDynamicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"eltyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"doctors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"isNameVisible"}},{"kind":"Field","name":{"kind":"Name","value":"nextAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"showOnPrivate"}}]}}]}}]} as unknown as DocumentNode<WorkgroupBySlugQueryResult, WorkgroupBySlugQueryVariables>;